/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import { useRecoilValue } from 'recoil';
import GoogleMapReact from 'google-map-react';
import styled from 'styled-components';
import { authSign, requestBev } from '../service/role';
import Marker from './Marker';
import logo from '../images/logo-thaibev.svg'
import iconavatar from '../images/icon-avatar.svg'
// import { history } from '../router/route';

import { Icon } from './Icon'
import { Navbar, Nav } from 'react-bootstrap'
// import SearchIcon from '@material-ui/icons/Search';
import { Cookies } from "react-cookie"

import { personState } from "../store"

// const AnyReactComponent = ({ text }) => <div>{text}</div>;

const Wrapper = styled.main`
  position: absolute;
  width: 100%;
  height: 100%;
`;
const apiIsLoaded = (map, maps, places) => {
    console.log(places)
    // // Get bounds by our places
    // const bounds = getMapBounds(map, maps, places);
    // // Fit map to bounds
    // map.fitBounds(bounds);
    // // Bind the resize listener
    // bindResizeListener(map, maps, bounds);
};

// const gotoLocation = () => {
//     history.push('/beacons-location')
//     history.go(0)
//   }

const BeaconeMap = () => {

    const [locations, setLocations] = useState([]);
    const [center, setCenter] = useState(undefined)
    const user = useRecoilValue(personState)

    const zoom = 12;

    useEffect(() => {
        reqAuthenSign()
    }, [])

    const reqAuthenSign = async () => {
        const res = await authSign()
        const cookies = new Cookies()
        if (res.data.status === true) {
            const params = {
                "work": "DASHBOARD.FEED.V3",
                "emp_id": cookies.get("profile").employeeid
            }
            
            const result = await requestBev(params)
            if (result.data.status === true) {
                if (result.data.result.locations.length > 0) {
                    setCenter({ lat: result.data.result.locations[0].latitude, lng: result.data.result.locations[0].longitude })
                    setLocations(result.data.result.locations)
                }
            }
        }
    }

    const handleLoaded = (value) => {
        console.log(value)
        setCenter({lat: value.latitude, lng: value.longitude})
    };
    return (
        <Wrapper id='map_wrapper'>
            <Navbar bg="white" variant="white">
                <Navbar.Brand href="#">
                    <img width="60" src={logo} alt="" />
                </Navbar.Brand>
                <Nav className="mr-auto">
                    <Nav.Link href="#" className="py-0 px-2">
                        <div className="media">
                            <Icon
                                className="align-self-center"
                                width={40}
                                height={40}
                                aria-hidden="true"
                                icon='BeaconIcon'
                                style={{ "color": "#027840" }}
                            />
                            <div className="media-body">
                                <h6 className="mb-0">Beacon Map</h6>
                                Dashboard Report
                            </div>
                        </div>
                    </Nav.Link>
                    {/* <Form inline>
                        <InputGroup.Prepend className='position-absolute'>
                            <InputGroup.Text id="basic-addon1" className="bg-white border-0 bg-transparent mt-1">
                                <SearchIcon></SearchIcon>
                            </InputGroup.Text>
                        </InputGroup.Prepend>
                        <FormControl
                            type="text"
                            className="mr-sm-2"
                            placeholder="ค้นหา"
                            style={{ paddingLeft: '2.5rem' }}
                        />
                    </Form> */}
                </Nav>
                {/* <Button variant="outline-light" className='border text-dark' onClick={gotoLocation}>
                    <Icon
                        className="align-self-center mr-2"
                        width={16}
                        height={24}
                        aria-hidden="true"
                        icon='BuildingIcon'
                        style={{ "color": "#027840" }}
                    />
                    All Locations
                </Button> */}
                <div className="media px-2">
                    <img src={iconavatar} alt={user ? user.profile ? user.profile.sub : '' : ''} className="align-self-center" />
                    <div className="media-body">
                        <p className="mb-0">{user ? user.profile ? user.profile.sub : '' : ''}</p>
                    </div>
                </div>

            </Navbar>
            <GoogleMapReact
                bootstrapURLKeys={{ key: "AIzaSyBz5e68I3h3QgqsHaR8yhJYoAUiswvRrqE" }}
                defaultCenter={center ? center : { lat: 13.736717, lng: 100.523186 }}
                defaultZoom={zoom}
                yesIWantToUseGoogleMapApiInternals={true}
                onGoogleApiLoaded={({ map, maps }) => apiIsLoaded(map, maps)}
            >
                {locations.map((place, _) => (
                    <Marker
                        key={place._id}
                        text={place}
                        onClick={handleLoaded}
                        lat={place.latitude}
                        lng={place.longitude} />
                )
                )}
            </GoogleMapReact>
        </Wrapper >

    )
}

export default BeaconeMap